import { Column, Entity, JoinTable, ManyToMany, PrimaryGeneratedColumn } from 'typeorm';
import { TamanhoPai } from './Tamanho';

@Entity()
export class TamanhoPadrao {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  descricao: string = '';

  @ManyToMany(() => TamanhoPai, { eager: true, cascade: true })
  @JoinTable({ name: 'tamanho_padrao_tem_tamanhos' })
  tamanhos!: TamanhoPai[];
}

export default TamanhoPadrao;
